<template>
  <div class="progress-bar">
    <div class="progress-bar__wrapper">
      <div class="progress-bar__progress">{{ progress }}%</div>
      <div class="progress-bar__separator"></div>
      <div class="progress-bar__name">
        {{ name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    name: {
      type: String,
      default: "",
    },
    percent: {
      type: Number,
      default: 0,
    },
    duration: {
      type: Number,
      default: 3000,
    },
  },
  data() {
    return {
      progress: 0,
    };
  },
  methods: {
    async runAnimation() {
      this.progress = 0;

      const delay = this.duration / 100 - 1;

      for (let i = 0; i <= this.percent; i++) {
        this.progress = i;
        this.setProgressWidth(i);
        await this.delay(delay);
      }
    },
    setProgressWidth(value) {
      this.$el?.style.setProperty("--progress-width", `${value}%`);
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.runAnimation();
            observer.unobserve(this.$el);
          }
        });
      },
      { threshold: 1 }
    );
    observer.observe(this.$el);
  },
};
</script>

<style lang="scss">
.progress-bar {
  position: relative;
  border-radius: 46px;
  width: 207px;
  backdrop-filter: blur(30px);
  background: #291f1f66;
  overflow: hidden;

  @include sm {
    border-radius: 6px;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: #291f1f;
    width: var(--progress-width, 0%);
    border-radius: 6px;
    transition: width 0.1s linear;
  }

  &__wrapper {
    position: relative;
    display: flex;
    gap: 8px;
    align-items: stretch;
    padding: 0 18px 0 12px;
    z-index: 1; 
  }

  &__progress {
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    color: #ffffff;
    min-width: 38px;
    max-width: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__separator {
    width: 1px;
    border-radius: 1px;
    flex-shrink: 0;
    background: #ffffff20;
    margin: 1px 0;
  }

  &__name {
    font-weight: 500;
    font-size: 12px;
    line-height: 120%;
    color: #ffffff;
    text-align: left;
    padding: 11px 0 10px 0;
  }
}
</style>